<div class="flex flex-row pr-4 text-nowrap">
  <div
    [class]="!readonly() ? 'cursor-pointer' : ''"
    class="flex flex-row flex-nowrap min-w-fit items-center gap-2"
    (click)="!readonly() && onClick.emit()"
  >
    @if (icon()) {
      <soft-icon [name]="icon()" class="mr-2 scale-150"></soft-icon>
    }
    <div class="flex flex-col w-full">
      <span class="text-sm font-semibold">{{ title() }}</span>
      <span [class.soft-link]="!readonly()" class="text-xs text-link">
        @let tmpl = template();
        @if (loading()) {
          <div class="skeleton h-4 w-full cursor-wait select-none rounded-sm">&nbsp;</div>
        }
        @if (!value()) {
          <em class="italic text-lighter">Keine Auswahl</em>
        } @else if (tmpl) {
          <ng-container
            *ngTemplateOutlet="tmpl; context: { value: value() }"
          ></ng-container>
        } @else {
          {{ value() }}
        }
      </span>
    </div>
  </div>
  @if (clearable() && value()) {
    <div
      class="flex flex-row justify-center items-center w-8 text-disabled"
      [ngClass]="{
        'text-text hover:text-danger pointer': !readonly(),
        'text-disabled': readonly(),
      }"
      (click)="clear.emit()"
    >
      <soft-icon name="fas fa-times" class="fa-sm"></soft-icon>
    </div>
  } @else if (clearable()) {
    <div class="w-8"></div>
  }
</div>
